/* eslint-disable react/style-prop-object */
import React from "react";

import BackgroundVideo from "../assets/DeadGodsVideoLoop.mp4";
import Parallax_visual from "../assets/parallax_visual.png";
import Frame from "../assets/frame.png";

import Logo from "../assets/degods_bitmap.svg";
import Hambuger from "../assets/hamburger.svg";
import Discord from "../assets/discord.svg";
import Twitter from "../assets/twitter.svg";
import Stardust1 from "../assets/stardust1.svg";

import LeandingPageHeader from "../components/headers/headers";

import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

export default function LeandingPage(props) {
    const [open, setOpen] = React.useState(false);

    return (
        <>
            <LeandingPageHeader open={open} setOpen={setOpen} />
            <div className="w-full overflow-y-auto bg-black relative" onClick={() => setOpen(false)}>
                <div className="relative w-full overflow-hidden">
                    <div className="absolute top-0 right-0 w-full px-10 py-4 bg-black-light space-x-8 flex flex-row items-center justify-center z-10">
                        <img src={Logo} alt="" className="w-6 md:w-10 cursor-pointer" />
                        <div className="flex-1"></div>
                        <img src={Hambuger} alt="" className="w-4 md:w-6 cursor-pointer hover:-translate-y-1 active:scale-90 transition-all duration-300" onClick={(e) => {
                            e.stopPropagation();
                            setOpen(!open)
                        }} />
                        <img src={Discord} alt="" className="w-6 cursor-pointer hidden sm:block hover:-translate-y-1 transition-all duration-300 active:scale-90" />
                        <img src={Twitter} alt="" className="w-6 cursor-pointer hidden sm:block hover:-translate-y-1 transition-all duration-300 active:scale-90" />
                        <button className="px-4 py-1 md:px-6 md:py-2 rounded-md bg-blue text-white text-xs md:text-base font-bold font-[monospace] transition-all duration-200 active:scale-95 hidden sm:block">
                            Select Wallet
                        </button>
                        <button className="px-4 py-1 md:px-6 md:py-2 rounded-md bg-blue text-white text-xs md:text-base font-bold font-[monospace] transition-all duration-200 active:scale-95 block sm:hidden">
                            <AccountBalanceWalletIcon color="#fff" fontSize="24" className="text-base" />
                        </button>
                    </div>
                    <div className="min-w-[400px] w-full">
                        <video src={BackgroundVideo} className="scale-150 md:scale-100" muted autoPlay preload="auto" loop />
                    </div>
                    <div className="flex flex-row items-center justify-center py-2 md:py-20">
                        <img src={Parallax_visual} alt="" className="w-[80%] lg:w-3/5 xl:w-2/5" />
                    </div>
                    <h2 className="text-base sm:text-xl md:text-4xl bg-hGradient w-fit bg-clip-text text-transparent m-auto mb-10 md:mb-32">Transcend your DeGod.</h2>
                    <div className="flex flex-col lg:flex-row items-center lg:items-start justify-around mb-28 px-4 md:mx-20">
                        <div>
                            <h2 className="mb-2 text-xl text-white">Step 1</h2>
                            <p className="text-base text-white text-opacity-40 mb-10">Choose a DeGod you wish to transcend</p>
                            <div className="w-full md:w-72 xl:w-80 h-80 md:h-96 bg-light-black rounded-md relative flex flex-col">
                                <div className="flex flex-1 flex-row items-center justify-center">
                                    <img src={Logo} alt="" className="w-10" />
                                </div>
                                <div>
                                    <p className="text-base text-white text-opacity-40 text-center">DeGod</p>
                                    <h2 className="mb-2 text-xl text-white text-center">0000</h2>
                                </div>
                            </div>
                        </div>
                        <span className="text-white text-4xl lg:mt-64">+</span>
                        <div>
                            <h2 className="mb-2 text-xl text-[#353535]">Step 2</h2>
                            <p className="text-base text-[#5e5757] text-opacity-40 mb-10">Buy $DUST to transcend to a DeadGod</p>
                            <div className="w-full md:w-72 xl:w-80 h-80 md:h-96 bg-dark-light-black rounded-md relative flex flex-col">
                                <div className="flex flex-1 flex-row items-center justify-center">
                                    <img src={Stardust1} alt="" className="w-32" />
                                </div>
                                <div>
                                    <p className="text-base text-[#353535] text-opacity-40 text-center">Price</p>
                                    <h3 className="mb-2 text-xl text-[#575757] text-center">1372.96 $DUST</h3>
                                </div>
                            </div>
                        </div>
                        <span className="text-white text-4xl lg:mt-64">=</span>
                        <div>
                            <h2 className="mb-2 text-xl text-[#353535]">Step 2</h2>
                            <p className="text-base text-[#5e5757] text-opacity-40 mb-10">Buy $DUST to transcend to a DeadGod</p>
                            <div className="w-full lg:w-72 xl:w-80 h-80 md:h-96 bg-dark-light-black rounded-md relative flex flex-col">
                                <img src={Frame} alt="" className="absolute w-full h-full" />
                                <div className="flex flex-1 flex-row items-center justify-center">
                                    <img src={Logo} alt="" className="w-10" />
                                </div>
                            </div>
                            <button className="bg-hGradient p-3 mt-9 rounded min-w-full text-sm uppercase text-center text-white">Transcend</button>
                        </div>
                    </div>
                    <div className="mb-10 px-4 md:mx-20">
                        <p className="text-2xl block text-white">Your DeGods</p>
                        <p className="text-base py-5 block text-white">Please connect your wallet</p>
                    </div>
                </div>
            </div>
        </>
    )
}
